import React from 'react';

const IFrame = ({ className, frameStyle, source, title, ...props }) => (
  <iframe title={title} className={className} src={source} frameBorder="0" {...props} />
);

export default IFrame;
